import React from "react";
import {SupportMail} from "../../../constants";
import {InlineLink, ListItem, Title, useTermsText} from "../TermsText";

const SmsSection = () => {
  const {openLink} = useTermsText();

  return (
    <>
      <Title>{"20. SMS."}</Title>

      <ListItem>
        {"When you opt in to the service, we will send you a one-time passcode on every attempt to log in."}
      </ListItem>

      <ListItem>
        {"You can cancel the SMS or MMS service at any time by texting “STOP” to 1-855-619-2302. When you send the SMS message “STOP” to us, we reply with an SMS message that confirms that you have been unsubscribed. After this, you won’t receive SMS any additional messages from us. If you want to join again, sign up as you did the first time and we will start sending SMS and MMS messages to you again."}
      </ListItem>

      <ListItem>
        {"You can get more information at any time by texting “HELP” to 1-855-619-2302. When you send the SMS message “HELP” to us, we respond with instructions on how to use our service and how to unsubscribe."}
      </ListItem>

      <ListItem>
        {"We are able to deliver messages to the following mobile phone carriers: Major carriers: AT&T, Verizon Wireless, Sprint, T-Mobile, MetroPCS, US Cellular, Alltel, Boost Mobile, Nextel, and Virgin Mobile. Minor carriers: Alaska Communications Systems (ACS), Appalachian Wireless (EKN), Bluegrass Cellular, Cellular One of East Central IL (ECIT), Cellular One of Northeast Pennsylvania, Cincinnati Bell Wireless, Cricket, Coral Wireless (Mobi PCS), COX, Cross, Element Mobile (Flat Wireless), Epic Touch (Elkhart Telephone), GCI, Golden State, Hawkeye (Chat Mobility), Hawkeye (NW Missouri), Illinois Valley Cellular, Inland Cellular, iWireless (Iowa Wireless), Keystone Wireless (Immix Wireless/PC Man), Mosaic (Consolidated or CTC Telecom), Nex-Tech Wireless, NTelos, Panhandle Communications, Pioneer, Plateau (Texas RSA 3 Ltd), Revol, RINA, Simmetry (TMP Corporation), Thumb Cellular, Union Wireless, United Wireless, Viaero Wireless, and West Central (WCC or 5 Star Wireless). Carriers are not liable for delayed or undelivered messages."}
      </ListItem>

      <ListItem mb={15}>
        {"Message and data rates may apply for any messages that we send to you or you send to us. You will receive one message per login attempt. Contact your wireless provider for more information about your text plan or data plan. If you have questions about the services provided by this short code, email us at "}<InlineLink
        onPress={() => openLink(`mailto:${SupportMail}`)}>{SupportMail}</InlineLink>{"."}
      </ListItem>
    </>
  );
};

export default React.memo(SmsSection);
